export enum EActionType {
  PRESET = 'preset',
  CUSTOM = 'custom',
}

type CommonProps = {
  isSelected: boolean;
  onClick: () => void;
};

type PresetProps = CommonProps & {
  actionType: EActionType.PRESET;
  value: number; // required
  currency?: string; // allowed (optional)
};

type CustomProps = CommonProps & {
  actionType: EActionType.CUSTOM;
  value?: never; // forbidden
  currency?: never; // forbidden
};

export type TProAmountButtonProps = PresetProps | CustomProps;
